import { useLocalization } from "@tm/localization"
import { Grid } from "@tm/components"
import { HighlightContrastTypography } from "../../StyledComponents"

type Props = {
    label?: string
    value?: number
    currencyCode?: string
}

export function Total({ label, value, currencyCode }: Props) {
    const { translateText, formatCurrency } = useLocalization()

    return (
        <>
            <Grid item xs={6}>
                {label && (
                    <HighlightContrastTypography>
                        {translateText(62)}
                        <HighlightContrastTypography variant="label">{` ${label}`}</HighlightContrastTypography>
                    </HighlightContrastTypography>
                )}
            </Grid>
            <Grid item xs={1} />
            {formatCurrency(value ?? 0, currencyCode ?? "-")
                .trim()
                .split(/\s+/, 2)
                .map((part) => (
                    <Grid key={part} item xs={3} textAlign="right">
                        <HighlightContrastTypography fontStyle={!label ? "italic" : "unset"}>{part}</HighlightContrastTypography>
                    </Grid>
                ))}
        </>
    )
}
